import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@sainsburys-tech/fable'

import TickInCircleLarge from '../../../assets/TickInCircleLARGE.svg'
import CrossInCircleLarge from '../../../assets/CrossInCircleLARGE.svg'
import '../../../sass/components/email-confirmation-modal.scss'

class EmailConfirmationModal extends React.Component {
  handleButtonClick = () => {
    const {
      history, closeModal, type, errorModal
    } = this.props
    if (type === 'unauthorised' || errorModal) {
      if (closeModal) {
        closeModal()
      }
    } else {
      history.push('/login')
    }
  }

  getBanner = () => {
    const { type, errorModal } = this.props

    if (errorModal) {
      return {
        variant: 'error',
        title: 'Verify your email address',
        iconSrc: CrossInCircleLarge,
        iconAlt: 'error'
      }
    }

    return {
      variant: 'success',
      title: type === '' ? 'Registration successful' : 'Email Sent',
      iconSrc: TickInCircleLarge,
      iconAlt: 'success'
    }
  }

  censorFirstWord = (str) => {
    if (str === null || str === '') {
      return null
    }
    if (str.length === 1) {
      return '*'
    }
    return str[0] + '*'.repeat(str.length - 1)
  }

  censorSecondWord = (str) => {
    if (str === null || str === '') {
      return null
    }
    if (str.length < 3) {
      return '*'.repeat(str.length)
    }
    if (!str.includes('.')) {
      return `${str[0] + '*'.repeat(str.length - 2) + str.slice(-1)}`
    }
    const val = str.split('.')
    if (val.length === 2) {
      return `${str[0] + '*'.repeat(val[0].length - 2) + val[0].slice(-1)}.${val[1]}`
    }
    return `${str[0] + '*'.repeat(val[0].length - 2) + val[0].slice(-1)}.${val[1]}.${val[2]}`
  }

  censorEmail = (email) => {
    if (email === null || email === '') {
      return ''
    }
    if (!email.includes('@')) {
      return this.censorFirstWord(email)
    }
    const arr = email.split('@')
    return `${this.censorFirstWord(arr[0])}@${this.censorSecondWord(arr[1])}`
  }


  displayText = () => {
    const { email, type } = this.props
    if (type === 'emailConfirmed') {
      const emailaddress = this.censorEmail(email)
      return (
        <p className="dsib-emailConfirmModal__text">
          We will send you an email to allow you to reset your password if you are a valid user (
          <strong>{emailaddress}</strong>
          ). Please ensure you verify your email before resetting the password.
        </p>
      )
    }
    if (type === 'unauthorised') {
      return (
        <>
          <p className="dsib-emailConfirmModal__text">
            You must verify your email address before you can reset your password.
          </p>
          <p className="dsib-emailConfirmModal__text dsib-emailConfirmModal__text--spaced">
            We&#39;ve just sent you an email (
            <strong>{email}</strong>
            ) that will allow you to verify your email address.
          </p>
        </>
      )
    }
    return (
      <p className="dsib-emailConfirmModal__text">
        We&#39;ve sent you an email to verify your email address (
        <strong>{email}</strong>
        ). You’ll need to follow the instructions in the email before you can log in.
      </p>
    )
  }

  render() {
    const { isModalOpen, type } = this.props
    const banner = this.getBanner()

    if (!isModalOpen) {
      return null
    }

    return (
      <div className="dsib-emailConfirmModalOverlay" aria-hidden="false">
        <div className="dsib-emailConfirmModalDialog" role="dialog" aria-modal="true" aria-label={banner.title}>
          <div className={`dsib-emailConfirmModal__banner dsib-emailConfirmModal__banner--${banner.variant}`}>
            <img className="dsib-emailConfirmModal__bannerIcon" src={banner.iconSrc} alt="" aria-hidden="true" />
            <div className="dsib-emailConfirmModal__bannerTitle">{banner.title}</div>
          </div>

          <div className="dsib-emailConfirmModal__body">
            {this.displayText()}

            <p className="dsib-emailConfirmModal__text dsib-emailConfirmModal__text--spaced">
              If you can’t find the email check your junk folder. Emails can sometimes take a while to arrive.
            </p>

            <div className="dsib-emailConfirmModal__cta">
              <Button
                isFullWidth
                variant="primary"
                onClick={this.handleButtonClick}
              >
                {type === 'unauthorised' ? 'Go to reset password' : 'Go to log in'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

EmailConfirmationModal.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
  errorModal: PropTypes.bool,
  type: PropTypes.string,
  closeModal: PropTypes.func,
}

EmailConfirmationModal.defaultProps = {
  errorModal: false,
  type: '',
  closeModal: null
}

export default EmailConfirmationModal
